export function truncateString(str: string, length: number = 40): string {
  if (str.length <= length) {
    return str;
  }
  return str.slice(0, length) + '…';
}

export function getDomainFromUrl(url: string): string {
  try {
    const urlObj = new URL(url);
    let hostname = urlObj.hostname;
    // Remove www. prefix if present
    if (hostname.startsWith('www.')) {
      hostname = hostname.slice(4);
    }
    return hostname;
  } catch (e) {
    return '';
  }
}
